export default __webpack_public_path__ + "static/3-62cdfcb558ba316721107b924e27e416.jpeg";